// 基础地址
// const base = 'http://192.168.110.106/';
const base = 'http://m.zkjan.com/';
const baseURL = 'http://m.zkjan.com/kstk-api/netuser/';
const basePay = 'http://m.zkjan.com/kstk-api/';
const xcxBase = 'http://m.zkjan.com/kstk-api/applet1/';

function goLogin(type,isReturn) {
	const t = type || 1;
	// location.href = base + 'pages/login/login.html?type=' + t + '&href=' + encodeURIComponent(location.href);
	
	localStorage.setItem('originalHref',location.href) 
	var realm = 'https://auth.zkjan.com'
	var url = '/login.html'
	if(t==2){
		url = '/register.html'
	}
	var href = realm + url +'?redirect_uri=' + encodeURIComponent('http://m.zkjan.com/pages/oauth/oauth.html')+'&appid='+'ZKJAN_PC_APPID'+'&href='+encodeURIComponent(location.href)
	if(isReturn){
		return href
	}else{
		location.href = href
	}
};

// 请求参数格式
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 请求拦截
axios.interceptors.request.use( config => {
	return config;
}, function (err) {
	return Promise.reject(err);
});
// 响应拦截
axios.interceptors.response.use( res => {
	let resData = res.data;
	switch (resData.code - 0) {
		case -3:
			goLogin(1)
			break;
		default:
			break;
	}
	return resData;
}, function (err) {
	return Promise.reject(err);
});

// 时间格式过滤器(年-月-日 时:分 / 2008-12-31 12:00)
Vue.filter('time', value => {
	let date = new Date(value);
	let	Y = date.getFullYear();
	let	m = date.getMonth() + 1;
	let	d = date.getDate();
	let	H = date.getHours();
	let	i = date.getMinutes();
	if (m < 10) {
		m = '0' + m;
	}
	if (d < 10) {
		d = '0' + d;
	}
	if (H < 10) {
		H = '0' + H;
	}
	if (i < 10) {
		i = '0' + i;
	}
	return Y + '-' + m + '-' + d + ' ' + H + ':' + i;
});
// 时间格式过滤器(年-月-日 / 2008-12-31)
Vue.filter('date', value => {
	let date = new Date(value);
	let	Y = date.getFullYear();
	let	m = date.getMonth() + 1;
	let	d = date.getDate();
	if (m < 10) {
		m = '0' + m;
	}
	if (d < 10) {
		d = '0' + d;
	}
	return Y + '-' + m + '-' + d;
});
// 数字转中文(一至十)
Vue.filter('chinaNum', index => {
	return ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'][index];
});

/**
*获取url参数
*@param {string} key 参数的key
*/
Vue.prototype.getQueryString = key => {
	let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
	let r = window.location.search.substr(1).match(reg);
	if (r != null) {
		return decodeURI(r[2]);
	}
	return null;
};
/**
 *验证是否登录
 */
Vue.prototype.checkLogin = (callback) => {
	let user = {};
	axios.post(baseURL + 'checkCookies')
		.then(res => {
			if (res.code == 200) {
				user.carCount = res.carCount;
				user.user = res.list;
			}
			if (res.code == -1) {
				user = null;
			}
			if (typeof callback == 'function') {
				callback(user);
			}
		})
		.catch(err => console.log(err));
};
/**
 *跳转登录
 */
Vue.prototype.goLogin = goLogin;
/**
 *验证手机号
 *@param {string} tel 手机号码
 */
Vue.prototype.isPhoneNumber = tel => {
	let reg = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[0-9])[0-9]{8}$/;
	return reg.test(tel);
};

/**
 *窗口滚动
 *@param {number} top 要滚动到的顶部位置
 */
Vue.prototype.scrollTo = top => {
	document.documentElement.scrollTop += 1;
	let i = 1;
	let b = document.documentElement.scrollTop ? document.documentElement : document.body;
	let s = (top - b.scrollTop) / 20;
	let stop = setInterval(() => {
		if (++i > 20) {
			b.scrollTop = top;
			clearInterval(stop);
			return;
		}
		b.scrollTop += s;
	}, 20);
};

/**
 *刷新页面
 */
Vue.prototype.reload = () => {
	location.reload();
};

/**
 *打开客服
 */
Vue.prototype.openServe = () => {
    if (document.getElementById('qimo_chatpup')) {
        qimoChatClick();
    }
};